import { Outlet, useLocation, Location } from "react-router-dom";
import { NotFound } from "../../pages/NotFound";
import { useHasAdministrationAccess } from "./hooks/useHasAdministrationAccess";
import { useMemo } from "react";
import ROUTES from "../../configs/routesConfig";
import { useHasProcessingAccess } from "./hooks/useHasProcessingAccess";
import { useHasDashBoardAccess } from "./hooks/useHasDashboardAccess";
import { useHasReportsAccess } from "./hooks/useHasReportsAccess";

export const PermissionContainer = () => {
  const { canViewAdministration } = useHasAdministrationAccess();

  const { canViewProcessing, canBatchView, canPaymentView } =
    useHasProcessingAccess();

  const { canViewDashboard } = useHasDashBoardAccess();

  const location: Location = useLocation();

  const { canViewReports } = useHasReportsAccess();

  const canView = useMemo(() => {
    const pathArray: string[] = location.pathname.split("/");

    if (pathArray.length > 0) {
      if (location.pathname === ROUTES.ADMINISTRATION) {
        return canViewAdministration;
      }

      if (pathArray[1] === ROUTES.PROCESSING.split("/")[1]) {
        if (pathArray.length === 2) {
          return canViewProcessing;
        }

        if (pathArray.length === 3) {
          return canBatchView;
        }

        if (pathArray.length === 5) {
          return canPaymentView;
        }
      }

      if (location.pathname === ROUTES.DASHBOARD) {
        return canViewDashboard;
      }

      if (location.pathname === ROUTES.REPORTS) {
        return canViewReports;
      }
    }

    return true;
  }, [
    location.pathname,
    canViewAdministration,
    canViewProcessing,
    canBatchView,
    canPaymentView,
    canViewDashboard,
    canViewReports,
  ]);

  return canView ? <Outlet /> : <NotFound />;
};
